class BuildaBundle extends HTMLElement {
  constructor() {
    super();
    this.brushList = this.querySelector('.bab-brush-list');
    this.totalItemCounts = this.querySelectorAll('.js-items-count');
    this.remainItems = this.querySelector('.js-remain-count');
    this.atcButton = this.querySelector('.js-bab-atc-sub-button');
    this.faceButton = this.querySelector('.js-bab-atc-face-button');
    this.addEventListener('change', this.onBundleUpdate.bind(this));
    this.atcButton.addEventListener('click', this.onButtonClick.bind(this));
    if (this.faceButton) {
      this.syncFaceButtonState();
      this.faceButtonObserver = new MutationObserver(() => this.syncFaceButtonState());
      this.faceButtonObserver.observe(this.atcButton, { attributes: true, attributeFilter: ['disabled'] });
      this.faceButton.addEventListener('click', this.onFaceButtonClick.bind(this));
    }
    this.mainImages = this.querySelectorAll('.build-a-bundle-product-image');
    this.imageThumbs = this.querySelectorAll('.build-a-bundle-product-image-thumb');

    this.imageThumbs.forEach((imageThumb) => {
        imageThumb.addEventListener('click', (e)=>{
            const thumb = e.target.closest('.build-a-bundle-product-image-thumb');
            if(thumb){
                const imageTarget = thumb.getAttribute('data-img-target');

                this.imageThumbs.forEach((img) => {
                    img.classList.remove('active');
                });
                thumb.classList.add('active');

                this.mainImages.forEach((img) => {
                    const imageHandle = img.getAttribute('data-img_handle');
                    if(imageHandle == imageTarget){
                        img.classList.add('active');
                    }else{
                        img.classList.remove('active');
                    }
                });
            }
        })
    })
  }

  onBundleUpdate(e) {
    const eTarget = e.target;

    if(eTarget.classList.contains('person-check-box-input')){
        this.resetUpperSelections();
        const tSection = this.querySelector(".build-a-bundle-sidebar");
        const offset = tSection.getBoundingClientRect().top + window.scrollY - 50;
        window.scrollTo({ top: offset, behavior: "smooth" });
    }
    
    this.updateBrushs();
    this.updatePersonCount();
    this.atcUpdates();
  }

  resetUpperSelections() {
    const qtyInputs = this.querySelectorAll(
      '.bab-block-canister-color-cell .quantity__input, .bab-block-brush-color-cell .quantity__input, .bab-block-flavor-cell .quantity__input'
    );

    qtyInputs.forEach((input) => {
      if ((parseInt(input.value, 10) || 0) === 0) return;
      input.value = '0';
      const qtyWrap = input.closest('bab-quantity-input');
      const minus = qtyWrap?.querySelector(".quantity__button[name='minus']");
      if (minus) minus.classList.add('disabled');
    });
  }

  updateBrushs() {
    const selectedBrushOption = this.querySelector('input[name="bab-block-brush-input"]:checked').value;

    if(selectedBrushOption == 'bam'){
        this.brushList.style.display = 'block';
    }else{
        this.brushList.style.display = 'none';
    }

    this.updatePersonPrice(selectedBrushOption);
  }

  updatePersonCount() { 
    const selectedPerson = this.querySelector('input[name="person-check-box-input"]:checked').value;
    this.remainCountContent = this.querySelector('.js-remain-count');
    this.remainBrushCountContent = this.querySelector('.js-remain-brush-count');
    this.remainCanisterCountContent = this.querySelector('.js-remain-canister-count');
    const addedItemFlavors = this.getFlavors(); 
    const addedItemBrushes = this.getBrushes(); 
    const addedItemCanisters = this.getCanisters(); 
    let selectedTotalFlavorsCount = 0;
    let selectedTotalBrushesCount = 0;
    let selectedTotalCanisterCount = 0;
    const plusFlavorButtons = this.querySelectorAll('.bab-block-flavor-cell button[name="plus"]');
    const plusBrushButtons = this.querySelectorAll('.bab-block-brush-color-cell button[name="plus"]');
    const plusCanisterButtons = this.querySelectorAll('.bab-block-canister-color-cell button[name="plus"]');

    addedItemFlavors.forEach((addedItemFlavor) => {
        selectedTotalFlavorsCount = selectedTotalFlavorsCount + parseInt(addedItemFlavor.count);
    });
    addedItemBrushes.forEach((addedItemBrush) => {
        selectedTotalBrushesCount = selectedTotalBrushesCount + parseInt(addedItemBrush.count);
    });
    addedItemCanisters.forEach((addedItemCanister) => {
        selectedTotalCanisterCount = selectedTotalCanisterCount + parseInt(addedItemCanister.count);
    });

    if(((parseInt(selectedPerson) * 4) - selectedTotalFlavorsCount) > 0){
        plusFlavorButtons.forEach((plusFlavorButton) => {
            plusFlavorButton.classList.remove('disabled');
        })
    }else{
        plusFlavorButtons.forEach((plusFlavorButton) => {
            plusFlavorButton.classList.add('disabled');
        })
    }
    this.remainCountContent.innerText = `${(parseInt(selectedPerson) * 4) - selectedTotalFlavorsCount}`;

    if(((parseInt(selectedPerson) * 2) - selectedTotalBrushesCount) > 0){
        plusBrushButtons.forEach((plusBrushButton) => {
            plusBrushButton.classList.remove('disabled');
        })
    }else{
        plusBrushButtons.forEach((plusBrushButton) => {
            plusBrushButton.classList.add('disabled');
        })
    }
    this.remainBrushCountContent.innerText = `${(parseInt(selectedPerson) * 2) - selectedTotalBrushesCount}`;

    if((parseInt(selectedPerson) - selectedTotalCanisterCount) > 0){
        plusCanisterButtons.forEach((plusCanisterButton) => {
            plusCanisterButton.classList.remove('disabled');
        })
    }else{
        plusCanisterButtons.forEach((plusCanisterButton) => {
            plusCanisterButton.classList.add('disabled');
        })
    }
    this.remainCanisterCountContent.innerText = `${parseInt(selectedPerson) - selectedTotalCanisterCount}`;

    this.totalItemCounts.forEach((totalItemCount) => {
        totalItemCount.innerText = `${parseInt(selectedPerson) * 4}`;
    })
  }

  getFlavors() {
    this.flavorsList = this.querySelectorAll('.bab-block-flavor-cell');
    this.flavor = [];

    this.flavorsList.forEach((flavorCell) => {
        const title = flavorCell.querySelector('.bab-block-flavor-cell-title').innerText;
        const variantid = flavorCell.getAttribute('data-variantid');
        const productid = flavorCell.getAttribute('data-productid');
        const subscriptionid = flavorCell.getAttribute('data-subscription');
        const count = flavorCell.querySelector('input').value;
        const flavorCellValue = {'title': title,'productid': productid, 'count': count, 'variantid': variantid, 'subscriptionid': subscriptionid };

        this.flavor.push(flavorCellValue);
    });

    return this.flavor;
  }

  getBrushes() {
    this.brushesList = this.querySelectorAll('.bab-block-brush-color-cell');
    this.brush = [];

    this.brushesList.forEach((brushcell) => {
        const title = brushcell.querySelector('.bab-block-brush-color-cell-title').innerText;
        const count = brushcell.querySelector('input').value;
        const variantid = brushcell.querySelector('.bab-block-brush-color-cell-label').getAttribute('data-variantid');
        const productid = brushcell.querySelector('.bab-block-brush-color-cell-label').getAttribute('data-productid');
        const subscriptionid = brushcell.querySelector('.bab-block-brush-color-cell-label').getAttribute('data-subscription');
        const brushCellValue = {'title': title,'productid': productid, 'count': count, 'variantid': variantid, 'subscriptionid': subscriptionid};

        this.brush.push(brushCellValue);
    });

    return this.brush;
  }

  getCanisters(){
    this.canisterList = this.querySelectorAll('.bab-block-canister-color-cell');
    this.canister = [];

    this.canisterList.forEach((canstercell) => {
        const title = canstercell.querySelector('.bab-block-canister-color-cell-title').innerText;
        const count = canstercell.querySelector('input').value;
        const variantid = canstercell.getAttribute('data-variantid');
        const productid = canstercell.getAttribute('data-productid');
        const colorHandle = canstercell.getAttribute('data-canister-color');
        const canstercellValue = {
          'title': title,
          'count': parseInt(count),
          'variantid': variantid,
          'productid': productid,
          'color': colorHandle || this.getCanisterColorToken(title)
        };

        this.canister.push(canstercellValue);
    });

    return this.canister;
  }

  syncFaceButtonState() {
    if (!this.faceButton || !this.atcButton) return;
    this.faceButton.disabled = this.atcButton.disabled;
    this.faceButton.textContent = this.atcButton.textContent;
  }

  wait(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  findRechargePortal() {
    return (
      document.querySelector('.recharge-component-bundle-form') ||
      document.querySelector('.rb-app .rb-subscription-card-form')?.closest('.rb-app') ||
      document.querySelector('.rb-app') ||
      document.querySelector('#recharge-storefront-bundling-widget') ||
      document.querySelector('[class*="recharge-component-bundle"]')
    );
  }

  findRechargeAtc(portal) {
    if (!portal) return null;
    return (
      portal.querySelector('button[type="submit"]') ||
      portal.querySelector('.rb-btn-primary') ||
      portal.querySelector('.rb-actions button') ||
      portal.querySelector('[class*="add-to-cart"] button') ||
      [...portal.querySelectorAll('button')].find((button) =>
        /add\s*to\s*cart/i.test((button.textContent || '').trim())
      )
    );
  }

  setNativeSelect(select, value) {
    if (!select || value == null) return false;
    const wanted = String(value).trim().toLowerCase();
    const option = [...select.options].find((opt) => {
      const optValue = String(opt.value || '').trim().toLowerCase();
      const optText = String(opt.textContent || '').trim().toLowerCase();
      return optValue === wanted || optText === wanted;
    }) || [...select.options].find((opt) => {
      const optText = String(opt.textContent || '').trim().toLowerCase();
      return optText.includes(wanted) || wanted.includes(optText);
    });
    if (!option) return false;

    const descriptor = Object.getOwnPropertyDescriptor(window.HTMLSelectElement.prototype, 'value');
    if (descriptor?.set) {
      descriptor.set.call(select, option.value);
    } else {
      select.value = option.value;
    }
    option.selected = true;

    select.dispatchEvent(new Event('input', { bubbles: true }));
    select.dispatchEvent(new Event('change', { bubbles: true }));
    return select.value === option.value || (select.selectedOptions[0]?.textContent || '').trim().toLowerCase() === wanted;
  }

  getRechargeFormSelects(portal) {
    if (!portal) return [];
    const inCard = [...portal.querySelectorAll('.rb-subscription-card-form select')];
    if (inCard.length) return inCard;
    return [...portal.querySelectorAll('select')].filter((select) => !select.closest('.rb-item'));
  }

  findSelectByOptionMatch(selects, matchers = []) {
    return (selects || []).find((select) => {
      const texts = [...select.options].map((opt) => String(opt.textContent || '').trim().toLowerCase());
      const values = [...select.options].map((opt) => String(opt.value || '').trim().toLowerCase());
      return matchers.every((matcher) => {
        const needle = String(matcher).toLowerCase();
        return texts.some((text) => text.includes(needle)) || values.some((value) => value.includes(needle));
      });
    });
  }

  async setRechargeChoice(portal, label) {
    const wantedLabel = String(label || '').trim();
    if (!wantedLabel) return false;
    const wanted = wantedLabel.toLowerCase();
    const selects = this.getRechargeFormSelects(portal);

    let targetSelect = null;
    if (/person|people/i.test(wantedLabel)) {
      targetSelect =
        this.findSelectByOptionMatch(selects, ['1 person']) ||
        this.findSelectByOptionMatch(selects, ['person']) ||
        selects[0];
    } else if (/toothbrush/i.test(wantedLabel)) {
      targetSelect =
        this.findSelectByOptionMatch(selects, ['include toothbrushes']) ||
        this.findSelectByOptionMatch(selects, ['toothbrush']) ||
        selects[1] ||
        selects[0];
    } else {
      targetSelect = selects.find((select) =>
        [...select.options].some((opt) => {
          const text = String(opt.textContent || '').trim().toLowerCase();
          const value = String(opt.value || '').trim().toLowerCase();
          return text === wanted || value === wanted || text.includes(wanted);
        })
      );
    }

    if (targetSelect && this.setNativeSelect(targetSelect, wantedLabel)) {
      await this.wait(50);
      const selectedText = (targetSelect.selectedOptions[0]?.textContent || '').trim().toLowerCase();
      if (selectedText === wanted || selectedText.includes(wanted) || wanted.includes(selectedText)) {
        return true;
      }
    }

    const scope =
      portal.querySelector('.rb-subscription-card-form') ||
      portal.querySelector('.rb-variant-selector') ||
      portal;
    const clickables = [
      ...scope.querySelectorAll(
        'button, label, li, [role="option"], [role="button"], .rb-option, .rb-select-option, .rb-variant, a'
      ),
    ].filter((node) => !node.closest('.rb-item'));

    const match = clickables.find((node) => {
      const text = (node.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
      return text === wanted || text.includes(wanted);
    });

    if (match) {
      match.click();
      return true;
    }

    return false;
  }

  findRbItem(portal, { productId, variantId, title } = {}) {
    const items = [...portal.querySelectorAll('.rb-item')];
    if (!items.length) return null;

    if (variantId) {
      const byVariant = items.find((item) => {
        const candidates = [
          item.getAttribute('data-rb-item-id'),
          item.getAttribute('data-rb-variant-id'),
          item.getAttribute('data-variant-id'),
          item.getAttribute('data-rb-item-variant-id'),
        ];
        return candidates.some((value) => value && String(value) === String(variantId));
      });
      if (byVariant) return byVariant;
    }

    if (productId) {
      const byProduct = items.filter((item) => {
        const candidates = [
          item.getAttribute('data-rb-item-id'),
          item.getAttribute('data-product-id'),
          item.getAttribute('data-rb-product-id'),
        ];
        return candidates.some((value) => value && String(value) === String(productId));
      });

      if (byProduct.length === 1) return byProduct[0];

      if (byProduct.length > 1) {
        const needle = String(title || '').trim().toLowerCase();
        if (needle) {
          const titled = byProduct.find((item) => {
            const text = (
              item.querySelector('.rb-title span')?.textContent ||
              item.querySelector('.rb-title')?.textContent ||
              item.querySelector('select')?.selectedOptions?.[0]?.textContent ||
              ''
            )
              .trim()
              .toLowerCase();
            const colorToken = needle.replace(/canister/g, '').trim();
            return (
              text === needle ||
              text.includes(needle) ||
              needle.includes(text) ||
              (colorToken && (text === colorToken || text.includes(colorToken)))
            );
          });
          if (titled) return titled;
        }
        return byProduct[0];
      }
    }

    const needle = String(title || '').trim().toLowerCase();
    if (!needle) return null;

    const titledMatches = items.filter((item) => {
      const text = (
        item.querySelector('.rb-title span')?.textContent ||
        item.querySelector('.rb-title')?.textContent ||
        ''
      )
        .trim()
        .toLowerCase();
      if (!text) return false;
      return text === needle || text.includes(needle) || needle.includes(text);
    });

    if (!titledMatches.length) return null;

    // Prefer Toothpaste Tabs over legacy Toothpaste Tablets duplicates.
    return (
      titledMatches.find((item) => {
        const label = `${item.getAttribute('aria-label') || ''} ${item.querySelector('.rb-title')?.textContent || ''}`;
        return /tabs/i.test(label);
      }) || titledMatches[0]
    );
  }

  async setRbItemQty(rbItem, targetQty) {
    if (!rbItem) return;
    const input = rbItem.querySelector('input');
    const plus =
      rbItem.querySelector('.rb-btn-qty-plus') ||
      rbItem.querySelector('button[aria-label*="Increase" i]') ||
      rbItem.querySelector('button[name="plus"]');
    const minus =
      rbItem.querySelector('.rb-btn-qty-minus') ||
      rbItem.querySelector('button[aria-label*="Decrease" i]') ||
      rbItem.querySelector('button[name="minus"]');

    let current = parseInt(input?.value || '0', 10) || 0;
    const desired = parseInt(targetQty, 10) || 0;
    let guard = 0;

    while (current > desired && minus && guard < 60) {
      minus.click();
      await this.wait(40);
      current = parseInt(input?.value || '0', 10) || 0;
      guard += 1;
    }

    while (current < desired && plus && guard < 120) {
      plus.removeAttribute('disabled');
      plus.classList.remove('tdisabled', 'disabled');
      plus.click();
      await this.wait(40);
      current = parseInt(input?.value || '0', 10) || 0;
      guard += 1;
    }

    if (input && current !== desired) {
      input.value = String(desired);
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }

    if (desired > 0) {
      rbItem.classList.add('rb-item--added');
      rbItem.classList.remove('tdisabled', 'to-40');
    }
  }

  getRbItemText(rbItem) {
    return (rbItem?.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
  }

  getCanisterColorToken(title) {
    return String(title || '')
      .replace(/canister/gi, '')
      .trim()
      .toLowerCase();
  }

  getRbItemTitleText(rbItem) {
    return (
      rbItem?.querySelector('.rb-title span')?.textContent ||
      rbItem?.querySelector('.rb-title')?.textContent ||
      ''
    )
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
  }

  rbItemMatchesCanisterColor(rbItem, canister) {
    const color = this.getCanisterColorToken(canister.color || canister.title);
    if (!color || !rbItem) return false;

    const titleText = this.getRbItemTitleText(rbItem);
    const fullText = this.getRbItemText(rbItem);
    const haystack = `${titleText} ${fullText}`;

    if (titleText === color || titleText.includes(color) || haystack.includes(color)) {
      const otherColors = ['green', 'white'].filter((entry) => entry !== color);
      return !otherColors.some((other) => titleText.includes(other) && !titleText.includes(color));
    }

    return false;
  }

  isCanisterRbItem(item, canisters = []) {
    if (!item) return false;

    const ids = [
      item.getAttribute('data-rb-item-id'),
      item.getAttribute('data-product-id'),
      item.getAttribute('data-rb-product-id'),
      item.getAttribute('data-rb-variant-id'),
      item.getAttribute('data-variant-id'),
      item.getAttribute('data-rb-item-variant-id'),
    ]
      .filter(Boolean)
      .map(String);

    if (
      canisters.some(
        (entry) => entry.productid && ids.includes(String(entry.productid))
      )
    ) {
      return true;
    }

    if (
      canisters.some(
        (entry) => entry.variantid && ids.includes(String(entry.variantid))
      )
    ) {
      return true;
    }

    if (canisters.some((entry) => this.rbItemMatchesCanisterColor(item, entry))) {
      return true;
    }

    const text = this.getRbItemText(item);
    return /aluminum|\bcans?\b|canister/.test(text);
  }

  findCanisterRbItems(portal, canisters = []) {
    return [...portal.querySelectorAll('.rb-item')].filter((item) =>
      this.isCanisterRbItem(item, canisters)
    );
  }

  findCanisterRbItem(portal, canister, canisterItems = []) {
    const items = canisterItems.length
      ? canisterItems
      : this.findCanisterRbItems(portal, [canister]);

    if (canister.variantid) {
      const byVariant = items.find((item) => {
        const candidates = [
          item.getAttribute('data-rb-variant-id'),
          item.getAttribute('data-variant-id'),
          item.getAttribute('data-rb-item-variant-id'),
          item.getAttribute('data-rb-item-id'),
        ];
        return candidates.some((value) => value && String(value) === String(canister.variantid));
      });
      if (byVariant) return byVariant;
    }

    if (canister.productid) {
      const byProduct = items.filter((item) => {
        const candidates = [
          item.getAttribute('data-rb-item-id'),
          item.getAttribute('data-product-id'),
          item.getAttribute('data-rb-product-id'),
        ];
        return candidates.some((value) => value && String(value) === String(canister.productid));
      });

      if (byProduct.length === 1) return byProduct[0];

      if (byProduct.length > 1) {
        const byColor = byProduct.find((item) => this.rbItemMatchesCanisterColor(item, canister));
        if (byColor) return byColor;
      }
    }

    const byColor = items.find((item) => this.rbItemMatchesCanisterColor(item, canister));
    if (byColor) return byColor;

    return (
      this.findRbItem(portal, {
        productId: canister.productid,
        variantId: canister.variantid,
        title: canister.title,
      }) ||
      this.findRbItem(portal, {
        productId: canister.productid,
        variantId: canister.variantid,
        title: this.getCanisterColorToken(canister.title),
      })
    );
  }

  async syncCanistersToRecharge(portal, canisters) {
    const canisterItems = this.findCanisterRbItems(portal, canisters);

    for (const rbItem of canisterItems) {
      await this.setRbItemQty(rbItem, 0);
    }
    await this.wait(150);

    for (const canister of canisters) {
      const qty = parseInt(canister.count, 10) || 0;
      const rbItem = this.findCanisterRbItem(portal, canister, canisterItems);

      if (!rbItem) {
        if (qty > 0) {
          console.warn('Build-a-bundle: canister Recharge item not found', canister);
        }
        continue;
      }

      await this.setRbItemQty(rbItem, qty);
      await this.wait(120);
    }
  }

  async syncSelectionsToRecharge() {
    const portal = this.findRechargePortal();
    if (!portal) {
      throw new Error('Recharge bundle widget not found');
    }

    const selectedPerson = this.querySelector('input[name="person-check-box-input"]:checked')?.value || '1';
    const selectedBrush = this.querySelector('input[name="bab-block-brush-input"]:checked')?.value || 'own';
    const personCount = parseInt(selectedPerson, 10) || 1;
    const personLabel = personCount === 1 ? '1 Person' : `${personCount} People`;
    const brushLabel = selectedBrush === 'bam' ? 'Include Toothbrushes' : 'Exclude Toothbrushes';

    const cardSelects = this.getRechargeFormSelects(portal);
    const personSelect =
      this.findSelectByOptionMatch(cardSelects, ['1 person']) ||
      this.findSelectByOptionMatch(cardSelects, ['person']) ||
      cardSelects[0];
    const toothbrushSelect =
      this.findSelectByOptionMatch(cardSelects, ['include toothbrushes']) ||
      this.findSelectByOptionMatch(cardSelects, ['toothbrush']) ||
      cardSelects[1];

    const personSet = await this.setRechargeChoice(portal, personLabel);
    await this.wait(personSet ? 400 : 200);
    const brushSet = await this.setRechargeChoice(portal, brushLabel);
    await this.wait(brushSet ? 400 : 200);

    if (!personSet) {
      console.warn('Build-a-bundle: failed to set Recharge person option', personLabel, personSelect);
    }
    if (!brushSet) {
      console.warn('Build-a-bundle: failed to set Recharge toothbrush option', brushLabel, toothbrushSelect);
    }

    const flavors = this.getFlavors();
    const brushes = this.getBrushes();
    const canisters = this.getCanisters();

    for (const flavor of flavors) {
      const rbItem = this.findRbItem(portal, {
        productId: flavor.productid,
        variantId: flavor.variantid,
        title: flavor.title,
      });
      await this.setRbItemQty(rbItem, flavor.count);
    }

    if (selectedBrush === 'bam') {
      for (const brush of brushes) {
        const rbItem = this.findRbItem(portal, {
          productId: brush.productid,
          variantId: brush.variantid,
          title: brush.title,
        });
        await this.setRbItemQty(rbItem, brush.count);
      }
    } else {
      for (const brush of brushes) {
        const rbItem = this.findRbItem(portal, {
          productId: brush.productid,
          variantId: brush.variantid,
          title: brush.title,
        });
        await this.setRbItemQty(rbItem, 0);
      }
    }

    await this.syncCanistersToRecharge(portal, canisters);

    await this.wait(300);
    return portal;
  }

  async clickRechargeAddToCart(portal = null) {
    const targetPortal = portal || this.findRechargePortal();
    const atc = this.findRechargeAtc(targetPortal);
    if (!atc) {
      throw new Error('Recharge Add to Cart button not found');
    }
    atc.disabled = false;
    atc.removeAttribute('disabled');
    atc.click();
  }

  getSelectedCanisters() {
    return this.getCanisters().filter(
      (item) => (parseInt(item.count, 10) || 0) > 0 && item.variantid
    );
  }

  async addSelectedCanistersToCart(canisters = this.getSelectedCanisters()) {
    const items = canisters
      .map((item) => ({
        id: parseInt(item.variantid, 10),
        quantity: parseInt(item.count, 10) || 0,
      }))
      .filter((item) => item.id && item.quantity > 0);

    if (!items.length) return null;

    const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ items }),
    });
    if (!response.ok) {
      throw new Error(await response.text());
    }
    return response.json();
  }

  isCartAddRequestUrl(url) {
    return /\/cart\/add(\.js)?(\?|$)/i.test(String(url || ''));
  }

  /**
   * Resolves on the next successful cart/add network response.
   * Event-driven via fetch/XHR hooks — no setInterval / cart.js polling.
   */
  waitForNextSuccessfulCartAdd() {
    return new Promise((resolve, reject) => {
      let settled = false;
      const originalFetch = window.fetch.bind(window);
      const originalOpen = XMLHttpRequest.prototype.open;
      const originalSend = XMLHttpRequest.prototype.send;
      const isCartAddUrl = (url) => this.isCartAddRequestUrl(url);

      const cleanup = () => {
        window.fetch = originalFetch;
        XMLHttpRequest.prototype.open = originalOpen;
        XMLHttpRequest.prototype.send = originalSend;
      };

      const finish = (ok, value) => {
        if (settled) return;
        settled = true;
        cleanup();
        if (ok) resolve(value);
        else reject(value instanceof Error ? value : new Error(String(value)));
      };

      window.fetch = async (...args) => {
        const response = await originalFetch(...args);
        const url = typeof args[0] === 'string' ? args[0] : args[0]?.url || '';
        if (isCartAddUrl(url) && response.ok) {
          finish(true, response);
        }
        return response;
      };

      XMLHttpRequest.prototype.open = function (method, url, ...rest) {
        this.__babCartMethod = method;
        this.__babCartUrl = url;
        return originalOpen.call(this, method, url, ...rest);
      };

      XMLHttpRequest.prototype.send = function (...args) {
        this.addEventListener(
          'load',
          () => {
            if (
              /post/i.test(this.__babCartMethod || '') &&
              isCartAddUrl(this.__babCartUrl) &&
              this.status >= 200 &&
              this.status < 300
            ) {
              finish(true, this);
            }
          },
          { once: true }
        );
        return originalSend.apply(this, args);
      };
    });
  }

  /**
   * Block client-side redirects (Recharge often navigates to /cart before we
   * can append canisters). No timers — only suppress location changes.
   */
  blockClientNavigations() {
    const locationDescriptor = Object.getOwnPropertyDescriptor(Location.prototype, 'href');
    const originalAssign = Location.prototype.assign;
    const originalReplace = Location.prototype.replace;
    const originalPushState = history.pushState;
    const originalReplaceState = history.replaceState;

    const shouldBlock = (url) => /\/cart|\/checkout/i.test(String(url || ''));

    Object.defineProperty(Location.prototype, 'href', {
      configurable: true,
      enumerable: true,
      get() {
        return locationDescriptor.get.call(this);
      },
      set(url) {
        if (shouldBlock(url)) return;
        locationDescriptor.set.call(this, url);
      },
    });

    Location.prototype.assign = function (url) {
      if (shouldBlock(url)) return;
      return originalAssign.call(this, url);
    };

    Location.prototype.replace = function (url) {
      if (shouldBlock(url)) return;
      return originalReplace.call(this, url);
    };

    history.pushState = function (...args) {
      if (shouldBlock(args[2])) return;
      return originalPushState.apply(this, args);
    };

    history.replaceState = function (...args) {
      if (shouldBlock(args[2])) return;
      return originalReplaceState.apply(this, args);
    };

    return () => {
      Object.defineProperty(Location.prototype, 'href', locationDescriptor);
      Location.prototype.assign = originalAssign;
      Location.prototype.replace = originalReplace;
      history.pushState = originalPushState;
      history.replaceState = originalReplaceState;
    };
  }

  /**
   * Canisters first, then sync + Recharge ATC.
   * Blocks early /cart navigation from Recharge until ATC cart/add finishes.
   */
  async runRechargeAddToCartWithCanisters() {
    const canisters = this.getSelectedCanisters();
    const unblockNavigation = this.blockClientNavigations();

    try {
      await this.addSelectedCanistersToCart(canisters);
      await this.syncSelectionsToRecharge();
      const cartAddDone = this.waitForNextSuccessfulCartAdd();
      await this.clickRechargeAddToCart();
      await cartAddDone;
    } finally {
      unblockNavigation();
    }

    window.location.assign(`${window.Shopify.routes.root}cart`);
  }

  /**
   * Alternate ATC: getBundleId + one cart/add (bundle + canisters). Kept unused by buttons.
   */
  async addBundleWithCanistersToCart() {
    const addedItemFlavors = this.getFlavors();
    const addedItemBrushes = this.getBrushes();
    const addedItemCanisters = this.getCanisters();
    const selectedVariant = this.getVariant();

    if (!selectedVariant?.variant_id) {
      throw new Error('Bundle variant not found for selected person/brush options');
    }

    const bundleProductData = {
      productId: bundle_product.id,
      variantId: selectedVariant.variant_id,
      sellingPlan: 6942687462,
      handle: 'toothpaste-subscription-fixed',
      collectionId: 484854137062,
    };

    const selections = [];
    const attributes = {};

    addedItemFlavors.forEach((item) => {
      if (parseInt(item.count, 10) > 0) {
        selections.push({
          collectionId: bundleProductData.collectionId,
          externalProductId: parseInt(item.productid, 10),
          externalVariantId: parseInt(item.variantid, 10),
          quantity: parseInt(item.count, 10),
        });
      }
    });

    if (this.querySelector('input[name="bab-block-brush-input"]:checked')?.value === 'bam') {
      addedItemBrushes.forEach((item) => {
        if (parseInt(item.count, 10) > 0) {
          selections.push({
            collectionId: bundleProductData.collectionId,
            externalProductId: parseInt(item.productid, 10),
            externalVariantId: parseInt(item.variantid, 10),
            quantity: parseInt(item.count, 10),
          });
        }
      });
    }

    const selection = {
      externalVariantId: bundleProductData.variantId,
      externalProductId: bundleProductData.productId,
      selections,
    };

    const _rb_id = await recharge.bundle.getBundleId(selection, {});
    const properties = { _rb_id };

    addedItemFlavors.forEach((item) => {
      if (parseInt(item.count, 10) > 0) properties[item.title] = item.count;
    });

    if (this.querySelector('input[name="bab-block-brush-input"]:checked')?.value === 'bam') {
      addedItemBrushes.forEach((item) => {
        if (parseInt(item.count, 10) > 0) properties[item.title] = item.count;
      });
    }

    addedItemCanisters.forEach((item) => {
      if (parseInt(item.count, 10) > 0) {
        attributes[item.title] = item.count;
        properties[`${item.title} Canister`] = item.count;
      }
    });

    const items = [
      {
        id: bundleProductData.variantId,
        quantity: 1,
        selling_plan: bundleProductData.sellingPlan,
        properties,
      },
    ];

    // Canisters are outside Recharge step-1 catalog — add as sibling lines
    // in the SAME cart/add request as the bundle.
    addedItemCanisters.forEach((item) => {
      if (parseInt(item.count, 10) > 0 && item.variantid) {
        items.push({
          id: parseInt(item.variantid, 10),
          quantity: parseInt(item.count, 10),
        });
      }
    });

    const addResponse = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ items }),
    });
    if (!addResponse.ok) {
      throw new Error(await addResponse.text());
    }

    await fetch(`${window.Shopify.routes.root}cart/update.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ attributes }),
    });

    window.location.href = '/cart';
  }

  onFaceButtonClick = async (event) => {
    event.preventDefault();
    event.stopPropagation();
    if (!this.faceButton || this.faceButton.disabled || this.atcButton?.disabled) return;

    this.faceButton.disabled = true;
    this.atcButton.disabled = true;
    try {
      await this.runRechargeAddToCartWithCanisters();
    } catch (error) {
      console.error('Build-a-bundle add to cart failed:', error);
      this.atcUpdates();
      this.syncFaceButtonState();
    }
  }

  updatePersonPrice(brushOption){
    const personSubBlocks = this.querySelectorAll('.bab-sub-count-block');

    personSubBlocks.forEach((personSubBlock) => {
        const personInput = personSubBlock.querySelector('input');
        const personPrice = personInput.getAttribute('data-price');
        const personBrushPrice = personInput.getAttribute('data-brush-price');
        const personCrossPrice = personInput.getAttribute('data-cross-price');
        const personOriginalPrice = personInput.getAttribute('data-original-price');
        const personPerPrice = personInput.getAttribute('data-person-price');
        const personPerBrushPrice = personInput.getAttribute('data-person-brush-price');
        const priceWrap = personSubBlock.querySelector('.m-price');
        const priceDWrap = personSubBlock.querySelector('.d-price');
        const pricePWrap = personSubBlock.querySelector('.p-price');
        if(brushOption == 'bam'){
            priceWrap.innerText = personBrushPrice;
            priceDWrap.innerText = personOriginalPrice;
            pricePWrap.innerText = personPerBrushPrice;
        }else{
            priceWrap.innerText = personPrice;
            priceDWrap.innerText = personCrossPrice;
            pricePWrap.innerText = personPerPrice;
        }
    })
  }

  atcUpdates(){
    const addedItemFlavors = this.getFlavors(); 
    const addedItemBrushes = this.getBrushes();
    const addedItemCanisters = this.getCanisters();
    const selectedPerson = this.querySelector('input[name="person-check-box-input"]:checked').value;
    let selectedTotalFlavorsCount = 0;
    let selectedTotalBrushesCount = 0;
    let selectedTotalCanistersCount = 0;
    let actAvailable = false;

    addedItemFlavors.forEach((addedItemFlavor) => {
        selectedTotalFlavorsCount = selectedTotalFlavorsCount + parseInt(addedItemFlavor.count);
    });
    addedItemBrushes.forEach((addedItemBrush) => { 
        selectedTotalBrushesCount = selectedTotalBrushesCount + parseInt(addedItemBrush.count);
    });
    addedItemCanisters.forEach((addedItemCanister) => { 
        selectedTotalCanistersCount = selectedTotalCanistersCount + parseInt(addedItemCanister.count);
    });

    if(this.querySelector('input[name="bab-block-brush-input"]:checked').value == 'bam'){
      if(((parseInt(selectedPerson) * 2) == selectedTotalBrushesCount) && ((parseInt(selectedPerson) * 4) == selectedTotalFlavorsCount) && (parseInt(selectedPerson) == selectedTotalCanistersCount)){
        actAvailable = true;
      }
    }else{
      if(((parseInt(selectedPerson) * 4) == selectedTotalFlavorsCount) && (parseInt(selectedPerson) == selectedTotalCanistersCount)){
        actAvailable = true;
      }
    }

    if(actAvailable){
        this.atcButton.disabled = false;
    }else{
        this.atcButton.disabled = true;
    } 
  }

  onButtonClick = async (event) => {
    event.preventDefault();
    this.atcButton.disabled = true;
    if (this.faceButton) this.faceButton.disabled = true;

    try {
      await this.runRechargeAddToCartWithCanisters();
    } catch (error) {
      console.error('Build-a-bundle add to cart failed:', error);
      this.atcUpdates();
      this.syncFaceButtonState();
    }
  }

  getVariant(){
    const selectedPerson = this.querySelector('input[name="person-check-box-input"]:checked').value;
    const availableVariants = bundle_p_variants.filter(bundle_p_variant => bundle_p_variant.person_count == selectedPerson);
    const selectedBrush = this.querySelector('input[name="bab-block-brush-input"]:checked').value;
    let selectedVariant = availableVariants[0];

    if(selectedBrush == 'bam'){
        return availableVariants.find(availableVariant => availableVariant.variant.option2 == "Include Toothbrushes");
    }else{
        return availableVariants.find(availableVariant => availableVariant.variant.option2 == "Exclude Toothbrushes");
    }
  }
}

customElements.define('build-a-bundle', BuildaBundle);

class BabQuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('bab-quantity-input', BabQuantityInput);